<div class="integration-form" *ngIf="integracaoFood99 && !integracaoFood99.removida">
  <div class="form-card">
    <header class="form-brand">
      <span class="integration-mark"><img src="/assets/icons/logo-99food.png" alt="99Food"></span>
      <div>
        <h3>{{integracaoFood99.nova ? 'Autorizar loja 99Food' : (integracaoFood99.nomeLoja || 'Loja 99Food')}}</h3>
        <p>{{integracaoFood99.nova ? 'Vincule sua loja ao Meu Cardápio.' : 'Gerencie o catálogo, os pedidos e a operação desta loja.'}}</p>
      </div>
    </header>

    <div class="alert alert-danger" role="alert" *ngIf="mensagemErro">
      <div class="d-flex align-items-center justify-content-between">
        <span><i class="k-icon k-i-warning mr-2"></i>{{mensagemErro}}</span>
        <button type="button" class="close" aria-label="Fechar" (click)="fecharAlerta()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>

    <ng-container *ngIf="!integracaoFood99.nova; else autorizacao">
      <section class="current-app current-integration">
        <div><small>ID vinculado</small><strong>{{integracaoFood99.idLoja || '—'}}</strong></div>
        <div><small>Ativada em</small><strong>{{integracaoFood99.dataAtivacao | date: 'dd/MM/yyyy'}}</strong></div>
        <div><small>Token válido até</small><strong>{{integracaoFood99.validadeToken ? (integracaoFood99.validadeToken | date: 'dd/MM/yyyy HH:mm') : '—'}}</strong></div>
      </section>

      <section class="form-section" *ngIf="integracaoFood99.id && !integracaoFood99.desativado">
        <div class="section-heading">
          <span class="step-number">1</span>
          <div><h4>Catálogo da loja</h4><p>Configure a publicação pelo canal de venda 99Food.</p></div>
        </div>
        <article class="service-option" [class.enabled]="publicacaoCatalogoHabilitada">
          <span class="service-icon"><i class="fas fa-cube"></i></span>
          <div class="service-copy"><strong>Publicação de catálogo</strong><small>Habilite para revisar e publicar produtos pelo Meu Cardápio.</small></div>
          <kendo-switch name="publicacaoCatalogoHabilitada" [(ngModel)]="publicacaoCatalogoHabilitada"
                        [disabled]="salvandoPublicacao" [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
        </article>
        <div class="section-actions">
          <button type="button" class="btn btn-primary"
                  [disabled]="salvandoPublicacao || publicacaoCatalogoHabilitada === (integracaoFood99.publicacaoCatalogoHabilitada === true)"
                  (click)="alterePublicacaoCatalogo(publicacaoCatalogoHabilitada)">
            <i class="fas fa-spinner fa-spin mr-1" *ngIf="salvandoPublicacao"></i>Salvar publicação de catálogo
          </button>
        </div>
      </section>

      <section class="form-section">
        <div class="section-heading">
          <span class="step-number">2</span>
          <div><h4>Operação da loja</h4><p>Consulte e altere a disponibilidade da loja no 99Food.</p></div>
        </div>
        <article class="service-option" [class.enabled]="estaAberta99Food() && !estaDesconectada99Food()">
          <span class="service-icon"><i class="fas fa-store"></i></span>
          <div class="service-copy">
            <strong>{{estaDesconectada99Food() ? 'Loja desconectada' : estaAberta99Food() === null ? 'Consultando status...' : estaAberta99Food() ? 'Loja aberta' : 'Loja fechada'}}</strong>
            <small *ngIf="statusMensagem99Food()">{{statusMensagem99Food()}}</small>
          </div>
          <ng-container *ngIf="estaAberta99Food() !== null && !estaDesconectada99Food()">
            <button class="btn" [ngClass]="estaAberta99Food() ? 'btn-outline-danger' : 'btn-outline-success'"
                    type="button" (click)="estaAberta99Food() ? fecharLoja99Food() : abrirLoja99Food()" [disabled]="ativando">
              <i class="fas mr-1" [ngClass]="ativando ? 'fa-spinner fa-spin' : 'fa-power-off'"></i>
              {{estaAberta99Food() ? 'Fechar a loja' : 'Abrir a loja'}}
            </button>
          </ng-container>
        </article>

        <div class="setting-row" *ngIf="estaAberta99Food()">
          <div class="setting-field">
            <label for="autoSwitch">Abertura/fechamento automático</label>
            <kendo-dropdownlist id="autoSwitch" name="autoSwitch" [data]="autoSwitchOpcoes"
              textField="text" valueField="value" [defaultItem]="{ text: 'Selecione...', value: null }"
              [(ngModel)]="autoSwitchSelecionado" [disabled]="ativando || salvandoAutoSwitch">
            </kendo-dropdownlist>
            <small class="form-text text-muted">{{explicacaoAutoSwitch()}}</small>
          </div>
          <button class="btn btn-primary" type="button" (click)="apliqueAutoSwitch()"
                  [disabled]="!autoSwitchSelecionado || salvandoAutoSwitch">
            <i class="fas fa-spinner fa-spin mr-1" *ngIf="salvandoAutoSwitch"></i>Aplicar
          </button>
        </div>
      </section>

      <section class="form-section">
        <div class="section-heading">
          <span class="step-number">3</span>
          <div><h4>Recebimento de pedidos</h4><p>As opções abaixo são aplicadas ao alterar a chave ou clicar em Aplicar.</p></div>
        </div>
        <div class="service-grid">
          <article class="service-option" [class.enabled]="integracaoFood99.aceitaCancelamento">
            <span class="service-icon"><i class="fas fa-ban"></i></span>
            <div class="service-copy"><strong>Solicitações de cancelamento</strong><small>Permite ao lojista intermediar os cancelamentos solicitados pelo cliente.</small></div>
            <kendo-switch name="aceitaCancelamento" [(ngModel)]="integracaoFood99.aceitaCancelamento"
              [onLabel]="'Sim'" [offLabel]="'Não'" (ngModelChange)="alterouAtivarAceitarCancelamento($event)"></kendo-switch>
          </article>
          <article class="service-option" [class.enabled]="integracaoFood99.aceitaReembolso">
            <span class="service-icon"><i class="fas fa-undo"></i></span>
            <div class="service-copy"><strong>Solicitações de reembolso</strong><small>Permite ao lojista intermediar os reembolsos solicitados pelo cliente.</small></div>
            <kendo-switch name="aceitaReembolso" [(ngModel)]="integracaoFood99.aceitaReembolso"
              [onLabel]="'Sim'" [offLabel]="'Não'" (ngModelChange)="alterouAtivarAceitarReembolso($event)"></kendo-switch>
          </article>
        </div>
        <div class="setting-row">
          <div class="setting-field">
            <label for="metodoConfirmacao">Método de confirmação de pedidos</label>
            <kendo-dropdownlist id="metodoConfirmacao" name="metodoConfirmacao" [data]="metodosConfirmacao"
              textField="text" valueField="value" [defaultItem]="{ text: 'Selecione...', value: null }"
              [(ngModel)]="metodoConfirmacao" [disabled]="ativando || salvandoMetodo">
            </kendo-dropdownlist>
            <small class="form-text text-muted">{{explicacaoMetodo()}}</small>
          </div>
          <button class="btn btn-primary" type="button" (click)="apliqueMetodoConfirmacao()"
                  [disabled]="!metodoConfirmacao || salvandoMetodo">
            <i class="fas fa-spinner fa-spin mr-1" *ngIf="salvandoMetodo"></i>Aplicar
          </button>
        </div>
        <p class="setting-note" *ngIf="metodoConfirmacao?.value === 1 || metodoConfirmacao === 1">
          <strong>Importante:</strong> o app do 99Food precisa estar online para aceitar ou cancelar pedidos pelo Meu Cardápio.
        </p>
        <p class="setting-note" *ngIf="metodoConfirmacao?.value === 2 || metodoConfirmacao === 2">
          A confirmação de pedidos será feita somente pelo Meu Cardápio. O app do lojista não poderá aceitar pedidos.
        </p>
      </section>

      <footer class="form-actions">
        <a class="btn btn-light" target="_blank" rel="noopener noreferrer" [href]="'/99food/lojas/me/' + indice">
          <i class="fas fa-external-link-alt mr-1"></i>Consultar loja
        </a>
        <button class="btn btn-outline-danger" type="button" (click)="confirmeRemover()" [disabled]="removendo">
          <i class="fas fa-trash-alt mr-1"></i>Remover integração
        </button>
      </footer>
    </ng-container>

    <ng-template #autorizacao>
      <form [ngClass]="{'was-validated': frm.submitted}" novalidate #frm="ngForm" (ngSubmit)="onSubmit()">
        <ng-container *ngIf="!integracaoFood99.authId">
          <section class="form-section">
            <div class="section-heading">
              <span class="step-number">1</span>
              <div><h4>Autorizar acesso no 99Food</h4><p>Abra o link e autorize o Meu Cardápio a acessar sua loja.</p></div>
            </div>
            <button class="btn btn-primary" type="button" (click)="gereLinkAutorizacao()" [disabled]="gerandoLink || ativando">
              <i class="fas mr-1" [ngClass]="gerandoLink ? 'fa-spinner fa-spin' : 'fa-external-link-alt'"></i>Autorizar loja
            </button>
          </section>
          <section class="form-section">
            <div class="section-heading">
              <span class="step-number">2</span>
              <div><h4>Informar a loja autorizada</h4><p>Depois de autorizar, copie o ID da loja no painel do 99Food.</p></div>
            </div>
            <div class="setting-row">
              <div class="setting-field">
                <label for="idLojaManual">ID da loja 99Food</label>
                <kendo-textbox id="idLojaManual" name="idLojaManual" [(ngModel)]="shopId"
                  placeholder="Ex: 123456" required #idLojaManualCtrl="ngModel"></kendo-textbox>
                <small class="text-danger" *ngIf="idLojaManualCtrl.touched && idLojaManualCtrl.errors?.required">Informe o ID da loja.</small>
              </div>
              <button class="btn btn-primary" type="button" (click)="ativeManualmenteLoja()"
                      [disabled]="ativando || !idLojaManualCtrl.valid">
                <i class="fas fa-spinner fa-spin mr-1" *ngIf="ativando"></i>Ativar integração
              </button>
            </div>
          </section>
        </ng-container>
        <section class="form-section" *ngIf="integracaoFood99.authId">
          <div class="section-heading">
            <span class="step-number"><i class="fas fa-check"></i></span>
            <div><h4>Selecionar loja autorizada</h4><p>Escolha qual loja deseja vincular ao Meu Cardápio.</p></div>
          </div>
          <div class="setting-field">
            <label for="lojaSelecionada">Loja disponível</label>
            <kendo-dropdownlist id="lojaSelecionada" name="lojaSelecionada" [(ngModel)]="integracaoFood99.lojaSelecionada"
              [data]="integracaoFood99.lojasAtivar" textField="name" valueField="id" required></kendo-dropdownlist>
          </div>
          <div class="store-preview" *ngIf="integracaoFood99.lojaSelecionada">
            <strong>{{integracaoFood99.lojaSelecionada.name}}</strong>
            <small>ID: {{integracaoFood99.lojaSelecionada.id}}</small>
            <small *ngIf="integracaoFood99.lojaSelecionada.address">{{integracaoFood99.lojaSelecionada.address}}</small>
          </div>
          <div class="section-actions">
            <button class="btn btn-primary" type="button" (click)="ativeLojaSelecionada()"
                    [disabled]="ativando || !integracaoFood99.lojaSelecionada">
              <i class="fas fa-spinner fa-spin mr-1" *ngIf="ativando"></i>Concluir integração
            </button>
          </div>
        </section>
        <footer class="form-actions">
          <button class="btn btn-light" type="button" (click)="cancelou.emit()" [disabled]="ativando">Cancelar</button>
        </footer>
      </form>
    </ng-template>
  </div>
</div>

<kendo-dialog *ngIf="confirmarRemover" [width]="500" (close)="canceleRemover()">
  <kendo-dialog-titlebar>Remover integração 99Food</kendo-dialog-titlebar>
  <p class="confirmation-message">Remover a integração impedirá o recebimento automático dos pedidos do 99Food.</p>
  <kendo-dialog-actions>
    <button class="btn btn-light" type="button" (click)="canceleRemover()" [disabled]="removendo">Cancelar</button>
    <button class="btn btn-danger" type="button" (click)="removerIntegracao()" [disabled]="removendo">
      <i class="fas fa-spinner fa-spin mr-1" *ngIf="removendo"></i>Remover integração
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
